import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormCheckmark = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormCheckmark' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='6 13 10.2 16.6 18 7' />
  </StyledIcon>
);
